import classNames from "components/ui/classNames";
import { FormattedMessage } from "react-intl";

interface IFilterButtonTabProps {
  labelText: React.ReactNode;
  totalCount: number;
  isSelected: boolean;
  onClick: () => void;
}

export default function FilterButtonTab({ labelText, totalCount, isSelected, onClick }: IFilterButtonTabProps) {
  return (
    <button
      type="button"
      role="tab"
      tabIndex={-1}
      aria-selected={isSelected}
      onClick={() => onClick()}
      className={classNames(
        "space-between group relative flex cursor-pointer appearance-none items-center border-none font-aeonik",
        "h-12 bg-white p-3 text-sm font-medium tracking-wide text-slate-700 no-underline transition-transform",
        "hover:rounded-lg hover:bg-slate-100 hover:font-bold hover:text-gray-900 active:scale-95",
        {
          "text-brand": isSelected,
        },
      )}
    >
      <div>
        <span
          className={classNames("flex text-sm font-medium group-hover:flex group-hover:font-bold", {
            "font-bold": isSelected,
          })}
        >
          {labelText}
        </span>

        <small
          className={classNames("font-medium group-hover:flex group-hover:text-slate-700", {
            "flex text-brand": isSelected,
            hidden: !isSelected,
          })}
        >
          {isSelected ? (
            <FormattedMessage defaultMessage="Filtrando" id="dDtfD6" />
          ) : (
            <FormattedMessage defaultMessage="Filtrar" id="VTfGzG" />
          )}
        </small>
      </div>

      <span
        className={classNames(
          "absolute right-1.5 flex h-9 w-9 items-center justify-center font-bold",
          "rounded-md bg-slate-100",
          "group-hover:bg-brand group-hover:text-white",
        )}
      >
        {totalCount}
      </span>
    </button>
  );
}
